const areas = [
  { name: "Groton", desc: "Brown County community northeast of Aberdeen on US-12" },
  { name: "Redfield", desc: "Spink County seat 40 miles southwest of Aberdeen" },
  { name: "Ipswich", desc: "Edmunds County community north of Aberdeen" },
  { name: "Webster", desc: "Day County seat 50 miles northeast of Aberdeen" },
  { name: "Milbank", desc: "Grant County seat 60 miles east of Aberdeen" },
  { name: "Watertown", desc: "Codington County largest city, 80 miles southeast on I-29" },
  { name: "Mobridge", desc: "Walworth County community on the Missouri River" },
  { name: "Frederick", description: "Brown County farm community north of Aberdeen" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Aberdeen and All of Northeastern South Dakota
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              The nearest passport agency to Aberdeen is in Minneapolis, over 290 miles east via I-29 and I-94. Fast Passport Center eliminates that trip entirely — serving Brown County, all northeastern SD communities, and the Glacial Lakes region.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Whether you are in downtown Aberdeen, near Northern State University, or in a surrounding prairie community, we handle your passport from door to door.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {areas.map((area, i) => (
                <div key={i} className="flex items-start gap-2.5 bg-[#F7F8FA] rounded-lg p-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#F6C344] text-base"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{area.name}</p>
                    <p className="text-gray-400 text-xs leading-snug">{area.desc || (area as { name: string; description?: string }).description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-lg overflow-hidden border border-gray-200 h-[420px]">
            <iframe
              title="Aberdeen South Dakota Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91300.5!2d-98.48647!3d45.46472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8791a63c3c6e1a0d%3A0x3e2a5e3e9b8d1f1!2sAberdeen%2C+SD!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}